require("aframe");
require("aframe-extras");

require("../src/index.sass");

AFRAME.registerComponent("change-scene", {
  init: function () {
    let sceneEl = this.el;
    let canvasEl = null;
    sceneEl.addEventListener("loaded", function () {
      // remove preview of scene
      canvasEl = document.querySelector(".a-canvas");
      canvasEl.style.display = "none";
    });
    sceneEl.addEventListener("enter-vr", function () {
      let canvasEl = document.querySelector(".a-canvas");
      canvasEl.style.display = "";
    });
    sceneEl.addEventListener("exit-vr", function () {
      let canvasEl = document.querySelector(".a-canvas");
      canvasEl.style.display = "none";
    });
  },
});

// start A-Frame Szene
const arButton = require('./ar-button');

document.addEventListener('DOMContentLoaded', (event) => {
  arButton();
});
